import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "styled-components";
var _excluded = ["helperText", "testId", "borderColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef } from 'react';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css'; // import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
// import { CalendarDaysIcon } from '@heroicons/react/24/solid';
// import { StyledDatePicker } from './date-picker.styles';

import TextInput from '../form/form.input';
import { format } from 'date-fns';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DatePicker(_ref) {
  var helperText = _ref.helperText,
      testId = _ref.testId,
      borderColor = _ref.borderColor,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  var mobileInputRef = useRef(null);

  var props = _objectSpread({}, inputProps); // const onHandleClick = () => {
  //   if (mobileInputRef.current) mobileInputRef.current.showPicker?.();
  // };


  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(TextInput, {
      id: props.id,
      type: 'date',
      value: props.value ? format(new Date(props.value), 'yyyy-MM-dd') : undefined,
      onChange: function onChange(value) {
        var _props$onChange;

        return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value);
      },
      testId: testId,
      bordercolor: borderColor,
      ref: mobileInputRef
    }), !!helperText && /*#__PURE__*/_jsx(HelperTextRElement, {
      helperText: helperText
    })]
  });
}
export var HelperTextRElement = function HelperTextRElement(_ref2) {
  var helperText = _ref2.helperText;
  return helperText ? /*#__PURE__*/_jsx(Title, {
    textColor: "red",
    fontWeight: "normal",
    fontSize: "small",
    children: helperText
  }) : null;
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "date-picker___StyledDiv",
  componentId: "sc-1ebvi90-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});